import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Upload, Button, Result } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { onUploadEvent } from 'utils/form';
import classNames from 'classnames';

import Client from 'containers/app/client';

import './style.css';

const SingleFileUpload = ({
  className,
  uploadTo,
  file,
  onChange,
  onClear,
  title,
  subTitle,
  ...rest
}) => {
  const customRequest = (e) => {
    Client.upload({ ...e, uploadTo });
  };

  const [fileList, setFileList] = useState(undefined);
  const customClassName = classNames(
    'ant-upload-drag',
    'ant-upload',
    'single-file-upload',
    className
  );

  return (
    <Upload
      style={{ width: '100%' }}
      customRequest={customRequest}
      fileList={fileList}
      onChange={(e) => {
        setFileList(onUploadEvent(e));
        onChange(e);
      }}
      {...rest}
    >
      <div className={customClassName}>
        {file ? (
          <Result
            status="success"
            title="Successfully Uploaded!"
            extra={[
              <Button
                key="buy"
                onClick={() => {
                  onClear();
                  setFileList(undefined);
                }}
              >
                Upload new
              </Button>,
            ]}
          />
        ) : (
          <>
            <p className="ant-upload-drag-icon">
              <UploadOutlined type="upload" />
            </p>
            {title ? <p className="ant-upload-text">{title}</p> : null}
            {subTitle ? <p className="ant-upload-hint">{subTitle}</p> : null}
          </>
        )}
      </div>
    </Upload>
  );
};

SingleFileUpload.propTypes = {
  uploadTo: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClear: PropTypes.func,
  onChange: PropTypes.func,
  file: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

SingleFileUpload.defaultProps = {
  className: undefined,
  file: undefined,
  onClear: () => {},
  onChange: () => {},
  title: null,
  subTitle: 'Click in this area to upload',
};

export default SingleFileUpload;
